import {action, observable} from 'mobx';
import SessionStore from "./SessionStore";
import {api, config} from "../config";

let obx = observable({
    /**
     * List available hybrid rooms.
     *
     * @function listAvailableRooms
     */
    availableRooms: [],
    proctorLocations: [],

    listAvailableRooms: action(async  function (callback = null) {
        SessionStore.startLoading('Loading...', 'listAvailableRooms');
        const url = `/hybrid/locations/rooms`;

        try{
            let response = await api.get(url)
            obx.availableRooms = response.data.rooms;
            obx.proctorLocations = response.data.locations;
            if (response.data.locations.length === 1 && callback) {
                // if there is only one location, we will hide the dropdown in HybridRooms, so we need to set the focused here
                obx.focusedProctorLocation = response.data.locations[0].proctorAccountLocationSid;
                callback();
            }
        } catch (error) {
            SessionStore.throwError(error);
        }
        SessionStore.finishLoading('listAvailableRooms');

    }),

    focusedProctorLocation: 'Default',

    setFocusedLocation: (proctorLocationSid) => {
        obx.focusedProctorLocation = proctorLocationSid;
    },

    installs: null,

    /**
     * Get all available installs.
     *
     * @async
     * @function listInstalls
     * @param {string} proctorSid
     */
    listInstalls: action(async proctorSid => {

        const url = `/proctors/${proctorSid}/permittedInstalls`;

        const response = await api.get(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                SessionStore.throwError(error);
            })

        return response.data.results;
    }),

    /**
     * Get all available courses for instructors.
     *
     * @async
     * @function listInstructorCourses
     * @param {string} installSid
     * @param {string} userSid
     */
    listInstructorCourses: action(async (installSid, userSid) => {

        const url = `/installs/${installSid}/courses?instructorSid=${userSid}`;

        const response = await api.get(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                SessionStore.throwError(error);
            })

        return response.data.results;
    }),

    /**
     * Add proctor to task router, create a proctor sync doc
     *
     * @async
     * @function createRoom
     * @param {object} payload
     */
    createProctorRoom: action(async (payload) => {
        SessionStore.startLoading('Loading...', 'createProctorRoom');

        const url = `/hybrid/proctors/location/${obx.focusedProctorLocation}/room`;

        await api.post(url, payload)
            .then(response => {
                SessionStore.finishLoading('createProctorRoom');
            })
            .catch(error => {
                SessionStore.throwError(error);
            });
    }),

    deleteProctorRoom: roomSid => {
        SessionStore.startLoading('Loading...', 'deleteProctorRoom');

        const url = `hybrid/rooms/${roomSid}`;

        api.delete(url)
            .then(response => {
                // Remove the room from the list because the page will not rerender after deletion
                obx.availableRooms.some((room, i) => {
                    if (room.sid === roomSid) {
                        obx.availableRooms.splice(i, 1);
                        return true;
                    } else {
                        return false;
                    }
                });

                SessionStore.finishLoading('deleteProctorRoom');
            })
            .catch(error => {
                SessionStore.throwError(error);
            });
    },

    roomDefaultValues: {},
    isEditing: false,

    stopEditing: () => {
        obx.roomDefaultValues = {};
        obx.isEditing = false;
    },

    startEditing: (roomDefaults) => {
        obx.roomDefaultValues = roomDefaults;
        obx.isEditing = true;
    },

    /**
     * Update a room’s settings.
     *
     * @async
     * @function updateRoom
     * @param {string} roomSid
     * @param {object} payload
     */
    updateProctorRoom: action(async (roomSid, payload) => {
        SessionStore.startLoading('updateProctorRoom');

        const url = `/hybrid/rooms/${roomSid}`;

        await api.patch(url, payload)
            .then(() => {
                SessionStore.finishLoading('updateProctorRoom');
                SessionStore.showToaster('Room settings saved', 'success')
            })
            .catch(error => {
                SessionStore.throwError(error);
            })
    }),
    editProctorRoomStartingOutside: action(async(roomSid) => {
        const index = obx.availableRooms.findIndex((room) => room.sid === roomSid);
        obx.startEditing(obx.availableRooms[index])

    }),

    joinHybridProctoringRoom: action(async (roomSid, domain = 'default') => {
        SessionStore.startLoading('Loading...', 'joinProctorRoom');

        const url = `/hybrid/proctors/join/rooms/${roomSid}`;

        const result = await api.get(url);

        const foundDomain =
            domain === 'alpha' ? config.hybridAlphaDomain :
            domain === 'beta' ? config.hybridBetaDomain :
            config.hybridDomain;

        SessionStore.finishLoading('joinProctorRoom');
        if (result.data.success) {
            const redirectUrl = `${foundDomain}/${roomSid}?proctorAccountUserSid=${result.data.proctorAccountUserSid}&spToken=${SessionStore.token}&clientToken=${result.data.token}`;

            window.open(redirectUrl, '_self');
        } else {
            SessionStore.throwError({
                response: {
                    data: {
                        message: 'You are already active in a hybrid room. If you just exited a room, it can take up to 10 seconds to make you inactive.'
                    }
                }
            });
        }
    }),

    checkoutSessionCount: 0,
    checkoutSessions: [],
    listCheckoutSessions: action(async (limit, offset, updateList = false) => {
        let url = `/proctors/${SessionStore.account.sid}/sessions/checkout`;

        if (limit && offset) {
            url += `?limit=${limit}&offset=${offset}`;
        } else if (limit) {
            url += `?limit=${limit}`;
        } else if (offset) {
            url += `?offset=${offset}`;
        }

        return await api.get(url)
            .then(result => {
                obx.checkoutSessionCount = result.data.total;

                if (updateList) {
                    obx.checkoutSessions = result.data.results;
                }

                return result.data;
            })
            .catch(error => {
                SessionStore.throwError(error)
            });
    })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/HybridStore.js